<template>
    <div id="">
        <div class="home-box">
  
                <div v-if="this._isMobile()">
                    <div class="content">
                        <div class="btn-down" @click="downApp()">
                        </div>
                        <div class="btn-info" @click="appInfo()">
                        </div>
                        <div class="btn-info-h5" @click="gotoh5()">
                        </div>
                        <!-- <img src="@/assets/maoz/new/Group 770.png" alt=""></img> -->
                        <img src="@/assets/maoz/new/Frame 752.png" alt="">
                        <img src="@/assets/maoz/new/Frame 719.png" alt="">
                        <img src="@/assets/maoz/new/Frame 718.png" alt="">
                        <img src="@/assets/maoz/new/Frame 717.png" alt="">
                        <img src="@/assets/maoz/new/Frame 716.png" alt="">
                        <img src="@/assets/maoz/new/Frame 715.png" alt="">
                        <img src="@/assets/maoz/new/Group 946.png" alt="">
                        <img src="@/assets/maoz/new/Frame 750.png" alt="">
                        <img src="@/assets/maoz/new/Frame 751.png" alt="">
                    </div>
                </div>
                <div v-else>
                    <div class="content-pc">
                        <div class="btn-down-pc" @click="downApp()">
                        </div>
                        <div class="btn-info-pc" @click="appInfo()">
                        </div>
                         <div class="btn-info-pc-h5" @click="gotoh5()">
                        </div>
                        <!-- <img src="@/assets/maoz/new/Group 770.png" alt=""></img> -->
                        <img src="@/assets/maoz/new/Frame 752.png" alt="">
                        <img src="@/assets/maoz/new/Frame 719.png" alt="">
                        <img src="@/assets/maoz/new/Frame 718.png" alt="">
                        <img src="@/assets/maoz/new/Frame 717.png" alt="">
                        <img src="@/assets/maoz/new/Frame 716.png" alt="">
                        <img src="@/assets/maoz/new/Frame 715.png" alt="">
                        <img src="@/assets/maoz/new/Group 946.png" alt="">
                        <img src="@/assets/maoz/new/Frame 750.png" alt="">
                        <img src="@/assets/maoz/new/Frame 751.png" alt="">
                    </div>
                </div>

            </div>



        </div>
    </div>

</template>

<script>
import {
    mapState,
    mapMutations
} from 'vuex'
import {
    GetHotBox,
    Rooms,
    PersonalInfo,
    GetNovice
} from '@/network/api.js'
import {
    Swiper,
    SwiperSlide,
    directive
} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import anymatch from 'anymatch'
import Axios from 'axios'
let _this = null;
export default {
    components: {
        Swiper,
        SwiperSlide,
    },
    directives: {
        swiper: directive,
    },
    name: 'Home',
    data() {
        return {

            time: 10000,
            Headlines: [],
            isShowBannerDetail: false,
            isShowPerson: false,  //新人奖励
            //gotoPersonBox: false,///登录成功后是否跳到新手宝箱
            //新宝箱类型
            boxType_0: [],
            boxType_1: [],
            boxType_2: [],
            boxType_3: [],

            ///banners
            banners: [
                //require("@/assets/images/banner/15.png"),
                //require("@/assets/images/banner/21.jpg"),
                require("@/assets/images/banner/23.jpg"),
                require("@/assets/images/banner/22.jpg"),



                //require("@/assets/images/banner/6.png"),
            ],
            swiperOption: {
                pagination: {
                    el: '.swiper-pagination',
                },
                //设置点击箭头
                // navigation: {
                // 	nextEl: '.swiper-button-next',
                // 	prevEl: '.swiper-button-prev',
                // },
                autoplay: {
                    delay: 10000,
                    //当用户滑动图片后继续自动轮播
                    disableOnInteraction: false,
                },
                slidesPerView: 1, // 张数
                paginationClickable: true,
                //spaceBetween: 10, // 间距
                loop: true,
                on: {
                    click: function (e) {
                        let index = e.target.getAttribute('data-idx');
                        if (index == 0) {
                            _this.Goto('/Sigin');

                        }
                    }
                }
            },

        }
    },


    created() {
        // _this = this;
        // this.ObtainHotBox()
        // this.GetRooms()

        // ///打开登录页面
        // this.$root.eventHub.$on('isShowPerson', () => {
        //     this.isShowPerson = true;
        // });


        // if (!sessionStorage.getItem('token')) {
        //     this.isShowPerson = true;
        // }


    },

    filters: {
        // GuoLvOne(val) {
        //     if (val.length > 14) {
        //         return val.substr(0, 14) + '...'
        //     } else {
        //         return val
        //     }
        // },
        // StyChoice(val) {
        //     console.log(val)
        //     if (val == '1') {
        //         return 'background: url(' + require('@/assets/images/Roll/back_huang.png') + ') no-repeat center bottom;background-size: contain;'
        //     } else if (val == '2') {
        //         return 'background: url(' + require('@/assets/images/Roll/back_fen.png') + ') no-repeat center bottom;background-size: contain;'
        //     } else if (val == '3') {
        //         return 'background: url(' + require('@/assets/images/Roll/back_lan.png') + ') no-repeat center bottom;background-size: contain;'
        //     } else if (val == '4') {
        //         return 'background: url(' + require('@/assets/images/Roll/back_hui.png') + ') no-repeat center bottom;background-size: contain;'
        //     } else {
        //         return 'background: url(' + require('@/assets/images/Roll/back_hui.png') + ') no-repeat center bottom;background-size: contain;'
        //     }
        // }
    },

    methods: {
                ///显示对战宝箱里面的饰品
        downApp() {
            //window.open('https://down.moreone.tw/moreone.apk');
        },
        appInfo() {
			this.$router.push('/Sigin')
        },
        gotoh5()
        {
        window.open('https://h5.oneshot-ko.com');
        },
        _isMobile() {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				)
				return flag
			},
    },


}
</script>
<style lang="scss">
body {
    -webkit-user-select: none;
    user-select: none;
}
.home-box {
	width: 100%;
                            .content{
                                width: 100%;

                                .btn-down {
                                    position: absolute;
                                    cursor: pointer;
                                    width: 94px;
                                    height: 38px;
                                    top: 205px;
                                    left: 75%;
                                    transform: translate(-50%, 0);
                                    background: url(../../assets/maoz/new/Group768.png);
                                    background-position: 50% center;
                                    background-repeat: no-repeat;
                                    background-size: 100%;
                                    font-size: 12px;
                                    line-height: 42px;
                                    text-align: center;
                                }
                                .btn-info {
                                    position: absolute;
                                    cursor: pointer;
                                    width: 94px;
                                    height: 38px;
                                    top: 205px;
                                    left: 50%;
                                    transform: translate(-50%, 0);
                                    background: url(../../assets/maoz/new/Group767.png);
                                    background-position: 50% center;
                                    background-repeat: no-repeat;
                                    background-size: 100%;
                                    font-size: 12px;
                                    line-height: 42px;
                                    text-align: center;
                                }
                                .btn-info-h5 {
                                    position: absolute;
                                    cursor: pointer;
                                    width: 94px;
                                    height: 38px;
                                    top: 205px;
                                    left: 25%;
                                    transform: translate(-50%, 0);
                                    background: url(../../assets/maoz/new/Group766.png);
                                    background-position: 50% center;
                                    background-repeat: no-repeat;
                                    background-size: 100%;
                                    font-size: 12px;
                                    line-height: 42px;
                                    text-align: center;
                                }
                            }
                            .content-pc
                            {     
                                width: 1920px;
                                .btn-down-pc {
                                    position: absolute;
                                    cursor: pointer;
                                    width: 298px;
                                    height: 235px;
                                    top: 1020px; /* 调整为所需的位置 */
                                    left: 1400px;
                                    transform: translate(-50%, -50%);
                                    background: url(../../assets/maoz/new/Group768.png);
                                    background-position: 50% center;
                                    background-repeat: no-repeat;
                                    background-size: 100%;
                                    font-size: 15px;
                                    line-height: 135px;
                                    text-align: center;
                                    //color: rgb(255, 255, 255);
                                }
                                .btn-info-pc {
                                    position: absolute;
                                    cursor: pointer;
                                    width: 298px;
                                    height: 235px;
                                    top: 1020px; /* 调整为所需的位置 */
                                    left: 950px;
                                    transform: translate(-50%, -50%);
                                    background: url(../../assets/maoz/new/Group767.png);
                                    background-position: 50% center;
                                    background-repeat: no-repeat;
                                    background-size: 100%;
                                    font-size: 15px;
                                    line-height: 135px;
                                    text-align: center;
                                    //color: rgb(255, 255, 255);
                                }
                                .btn-info-pc-h5 {
                                    position: absolute;
                                    cursor: pointer;
                                    width: 298px;
                                    height: 235px;
                                    top: 1020px; /* 调整为所需的位置 */
                                    left: 500px;
                                    transform: translate(-50%, -50%);
                                    background: url(../../assets/maoz/new/Group766.png);
                                    background-position: 50% center;
                                    background-repeat: no-repeat;
                                    background-size: 100%;
                                    font-size: 15px;
                                    line-height: 135px;
                                    text-align: center;
                                    //color: rgb(255, 255, 255);
                                }
                            }

    .Roll {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        margin-bottom: 20px;

        .Roll_item {
            width: 440px;
            height: 180px;
            border-radius: 4px;
            background: url(../../assets/images/Roll/itemback1.png) no-repeat center;
            background-size: 100% 100%;
            padding: 20px 20px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            cursor: pointer;
            transition: 0.3s;

            &:hover {
                transform: translateY(-10px);
                box-shadow: #e9b10e 0px 0px 5px;
            }

            &:nth-child(2) {
                background: url(../../assets/images/Roll/itemback2.png) no-repeat center;
                background-size: 100% 100%;
            }

            &:nth-child(3) {
                background: url(../../assets/images/Roll/itemback3.png) no-repeat center;
                background-size: 100% 100%;
            }

            .Roll_right {
                width: 280px;
                height: 100%;
                position: relative;
                .Roll_tit {
                    font-size: 18px;
                    color: #e9b85a;
                    font-family: 'Oxanium';
                }

                .JG {
                    color: #e9b85a;
                    display: block;
                    font-size: 18px;
                    margin-top: 6px;
                    height: 25px;
                    font-family: 'Oxanium';
                                 
                    img {
                        vertical-align: middle;
                        width: 22px;
                    }
                }

                .DJS {
                    position: absolute;
                    top: 125px;
                    width: 250px;
                    height: 70px;
                    background-size: 100% 80%;
                    box-sizing: border-box;

                    .van-count-down {
                        height: 100%;
                        .colon {
                            display: inline-block;
                            margin: 0 4px;
                            color: #fff;
                        }

                        .block {
                            display: inline-block;
                            width: 190px;
                            color: #fff;
                            font-size: 22px;
                            font-family: 'Oxanium';

                        }
                    }
                }

                .room-people {
                    margin-top: 4px;
                    color: #a0a9d6;
                    font-size: 18px;
                    font-family: 'Oxanium';
                    img {
                        vertical-align: middle;
                        width: 22px;
                    }
                }
            }

            .Roll_left {
                width: 180px;
                height: 100%;
                position: relative;

                .Roll_pic {
                    width: 130px;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    img {
                        max-width: 100%;
                        max-height: 100%;
                    }
                }

                p {
                    position: absolute;
                    bottom: -8px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-family: "Oxanium";
                }
            }
        }
    }

    .home-List-box {
        width: 100%;
        .box_type_title {
            width: 100%;
            height: 100px;
            display:  flex;
            align-items:  center;
            justify-content : center;
            //background: url(../../assets/images/new-ui/box_type_title.png) no-repeat center;
            //background-size: 100% 100%;
            p {
                position: absolute;
                font-size: 20px;
                font-weight: bold;
                margin-top: 19px;
                margin-left: 20px;
            }
            img{
                max-width: 100%;
            }
        }

        .Blind_boxS {
            width: 100%;
            display: flex;
            position: relative;
            flex-wrap: wrap; ///超出容器自动换行

            .Blind_item {
                position: relative;
                width: 280px;
                height: 280px;
                .top {
                    width: 100%;
                    position: relative;
                    .pic_w {
                        width: 180px;
                        height: 100%;
                        position: absolute;
                        left: 50px;
                        top: 0px;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        .img-container {
                            max-width: 100%;
                            max-height: 100%;
                            transition: 0.3s;
                        }

                        .img-container img {
                            width: 100%;
                            height: 100%;
                            transition: 0.3s;
                        }
                    }

                    .pic_m {
                        position: relative;
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        img {
                            max-width: 100%;
                            max-height: 100%;
                            vertical-align: middle;
                        }
                    }

                    .item_tag {
                        position: absolute;
                        background-image: linear-gradient(to right, #cf1f70, #e920ca);
                        left: 40px;
                        width: 40px;
                        height: 22px;
                        top: 30px;
                        border-radius: 2px;
                        text-align: center;
                        justify-content: center;

                        p {
                            margin-top: 5px;
                            color: #ffffff;
                            font-size: 12px;
                            font-weight: bold; ///字体加粗
                        }
                    }

                    .item_tag_yellow {
                        position: absolute;
                        background-image: linear-gradient(to right, #cf1f70, #e920ca);
                        left: 40px;
                        width: 40px;
                        height: 22px;
                        top: 30px;
                        border-radius: 2px;
                        text-align: center;
                        justify-content: center;
                        p {
                            margin-top: 5px;
                            color: #ffffff;
                            font-size: 12px;
                            font-weight: bold; ///字体加粗
                        }
                    }

                    .item_price {
                        position: absolute;
                        background-color: rgba(12, 11, 16, 0.8);
                        right: 40px;
                        top: 30px;
                        width: 90px;
                        height: 22px;
                        border-radius: 2px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .cp {
                            color: #ffcb77;
                            height: 15px;
                            font-size: 14px;
                            font-family: "Oxanium";
                 
                            img {
                                width: 15px;
                                height: 15px;
                                vertical-align: middle;
                            }
                        }
                    }

                    .item_name {
                        position: absolute;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        left: 60px;
                        bottom: 40px;
                        width: 160px;
                        height: 26px;
                        background-color: rgba(12, 11, 16, 0.7);
                        border-radius: 2px;
                        z-index: 2;
                        text-overflow: ellipsis;
                        white-space: nowrap;

                        p {
                            color: #ffffff;
                            font-size: 14px;
                        }
                    }

                    &:hover {
                        .pic_w {
                            img {
                                transform: translateY(-20px);
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>